import { render, staticRenderFns } from "./UnauthenticatedLayoutHeader.vue?vue&type=template&id=157cbac0&scoped=true&"
import script from "./UnauthenticatedLayoutHeader.vue?vue&type=script&lang=ts&"
export * from "./UnauthenticatedLayoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UnauthenticatedLayoutHeader.vue?vue&type=style&index=0&id=157cbac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cbac0",
  null
  
)

export default component.exports